module.exports = __webpack_public_path__ + "static/media/plus.9edef4bc.svg";